export const DEFAULT_SECTION_ORDER = [
  "submitted_by",
  "project_info",
  "client",
  "project_team",
  "scope_of_work",
  "pricing",
  "signature_block",
];

export const SECTION_ORDER_LABELS = {
  submitted_by: "Submitted By",
  project_info: "Project Information",
  client: "Customer",
  project_team: "Project Team",
  scope_of_work: "Scope of Work",
  pricing: "Pricing",
  signature_block: "Signature Block",
};

export const getDefaultSectionOrder = () => [...DEFAULT_SECTION_ORDER];

const mergeOrder = (saved, fallback) => {
  const list = Array.isArray(saved)
    ? saved.filter((id) => fallback.includes(id))
    : [];
  fallback.forEach((id) => {
    if (!list.includes(id)) {
      list.push(id);
    }
  });
  return list;
};

export const normalizeSectionOrder = (order) => {
  const defaults = getDefaultSectionOrder();
  if (Array.isArray(order)) {
    return mergeOrder(order, defaults);
  }
  if (order && typeof order === "object") {
    return mergeOrder(
      [...(order.page1 || []), ...(order.page2 || [])],
      defaults
    );
  }
  return defaults;
};

export const reorderList = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
